module.exports = __webpack_public_path__ + "img/city (4).7f20a198.png";